import React from 'react';
import loader from '../spinning-circles.svg'

const Loader = () : JSX.Element => {
    return(
        <div className="loader">
            Loading...
        </div>
    )
}

export default Loader;
